export const METRIKA_COUNTER_ID = 111612622;

export const METRIKA_GOALS = Object.freeze({
  SELECT_SCHOOL: 'selectSchool',
  SELECT_PERSONAL: 'selectPersonal',
  SELECT_AI: 'selectAi',
});

const ALLOWED_GOALS = new Set(Object.values(METRIKA_GOALS));

/**
 * Records only a predefined funnel goal. The helper intentionally accepts no
 * parameters or visitor data, so names, contacts and other PII cannot be sent
 * through this integration by mistake.
 */
export function reachGoal(goal) {
  if (!ALLOWED_GOALS.has(goal)) return false;
  if (
    typeof window === 'undefined' ||
    !window.GlotovCookieConsent ||
    window.GlotovCookieConsent.getChoice() !== 'analytics' ||
    typeof window.ym !== 'function'
  ) {
    return false;
  }

  try {
    window.ym(METRIKA_COUNTER_ID, 'reachGoal', goal);
    return true;
  } catch (error) {
    return false;
  }
}
